<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container  " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>کاشت مو بانوان   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>کاشت مو به تکنیک جراحی گفته می‌شود که در آن ریشه‌های مو، تک تک از ناحیه اهداکننده به ناحیه در حال ریزش یا خالی از مو برده می‌شوند. طی آن ریشه‌هایی که به صورت ژنتیکی در مقابل ریزش مقاوم هستند به ناحیه طاس برده می‌شوند.
   </template>
                </m-h4><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5 " >
                <template #default>
   </template>
                </m-h4><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a-\u0645\u0648\/IMG_7653.JPG","alt":"\u06a9\u0627\u0634\u062a \u0645\u0648 \u0622\u0631\u0627"},...{}}' :style='"height:900px;\nobject-fit:contain;"' class="img-fluid mx-auto col-12 my-5" ></m-img><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a-\u0645\u0648\/IMG_7655.JPG","alt":"\u06a9\u0627\u0634\u062a \u0645\u0648 \u0622\u0631\u0627"},...{}}' :style='"height:900px;\nobject-fit:contain;"' class="img-fluid mx-auto col-12 my-5" ></m-img><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a-\u0645\u0648\/IMG_7591.JPG","alt":"\u06a9\u0627\u0634\u062a \u0645\u0648 \u0622\u0631\u0627"},...{}}' :style='"height:900px;\nobject-fit:contain;"' class="img-fluid mx-auto col-12 my-5" ></m-img></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
